import { UploadType } from '@quicktools/shared-components/components/core/UploadArea';

export type ShopBackgroundItem = {
  id: number;
  url: string;
  preview_url: string;
  tag: string | null;
  license?: string;
};

export type ShopBackgrounds = {
  type?: string;
  items: ShopBackgroundItem[];
  shop_item_uid?: string;
  name?: string;
  license?: string;
  icon?: string;
  commercial?: boolean;
};

export type DataToUpload = {
  files: File[] | string[];
  uploadType?: UploadType;
};

export enum PageType {
  Landing = 'landing',
  Editor = 'main',
}
